import api from "../api";
import {ElMessage} from "element-plus";

export default {
    namespaced: true,
    state: {
        property_typologies: {data: [], current_page: 1, total: 0, per_page: 10},
        errors: {
            data: {
                errors: {}
            }
        },
        has_errors: false,
        loading:false,
        dialogVisible: false,
    },
    getters: {
        dialogVisible: state => state.dialogVisible,
        loading: state => state.loading,
        property_typologies: state => state.property_typologies,
        errors: state => state.errors,
        has_errors: state => state.has_errors,
    },
    mutations: {
        setDialogVisible(state, status) {
            state.dialogVisible = status;
        },
        setLoading(state, data) {
            state.loading= data;
        },
        setPropertyTypologies(state, data) {
            state.property_typologies = data;
        },
        setErrors(state, errors) {
            state.errors = errors
        },
        hasErrors(state, val) {
            state.has_errors = val
            if (!val) {
                state.errors = {
                    data: {
                        errors: {}
                    }
                };
            }
        }
    },
    actions: {
        async getPropertyTypologies({commit}, filters) {
            commit('setLoading', true);
            try {
                const response = await api.getPropertyTypologies(filters);
                commit('setPropertyTypologies', response);
                commit('setLoading', false);
            } catch (e) {
                ElMessage.error(e.response.data.message);
                commit('setLoading', false);
            }
        },

        async createPropertyTypologies({dispatch, commit}, data) {
            try {
                commit('hasErrors', false)
                await api.createPropertyTypologies(data);
                ElMessage.success('property typology created successfully!');
                commit('setDialogVisible',false)
                dispatch('getPropertyTypologies', {
                    paginate: true
                })
            } catch (e) {
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error(e.response.data.message);
            }
        },
        async editPropertyTypologies({dispatch, commit}, data) {
            try {
                await api.editPropertyTypology(data);
                ElMessage.success('property typology updated successfully!');
                commit('setDialogVisible',false)
                dispatch('getPropertyTypologies', {
                    paginate: true
                })
            } catch (e) {
                ElMessage.error(e.response.data.message);
            }
        },
        async deletePropertyTypologies({commit,dispatch}, data) {
            commit('setLoading', true);
            try {
                const response = await api.deletePropertyTypology(data);
                commit('setLoading', false);
                dispatch('getPropertyTypologies', {
                    paginate: true
                })
                if (response.status === 401) {
                    ElMessage.warning({
                        message:response.message,
                        duration:10000
                    });
                } else {
                    ElMessage.success({
                        message:response.message,
                        duration:10000
                    });
                }
            } catch (e) {
                ElMessage.error(e.response.data.message);
                commit('setLoading', false);
            }
        },
        openDialogVisible({commit}, status) {
            commit('setDialogVisible', status);
        },

    }
}
